import { render } from "./QuestTypeLabel.vue?vue&type=template&id=1928bb46&scoped=true"
import script from "./QuestTypeLabel.vue?vue&type=script&lang=js"
export * from "./QuestTypeLabel.vue?vue&type=script&lang=js"

import "./QuestTypeLabel.vue?vue&type=style&index=0&id=1928bb46&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1928bb46"]])

export default __exports__